import { render, staticRenderFns } from "./CodemirrorShowModalBtn.vue?vue&type=template&id=02246038"
import script from "./CodemirrorShowModalBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./CodemirrorShowModalBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports